import { withInstall } from '@pc-fx-framework/utils/with-install'
import VSpireColumnChart from './src/index.vue'

export const FxVSpireColumnChart = withInstall(VSpireColumnChart)
export default FxVSpireColumnChart

export * from './src/types'
